module.exports = __webpack_public_path__ + "static/media/paco.93a502f5.png";